import { FaPlane, FaShip, FaBoxOpen, FaFileAlt } from 'react-icons/fa';
import SectionTitle from './ui/SectionTitle';
import StepCard from './ui/StepCard';
import './Export.css';

const REGIONS = [
  'United States', 'United Kingdom', 'Germany', 'France',
  'UAE', 'Saudi Arabia', 'Australia', 'Canada',
  'Netherlands', 'Italy', 'South Korea', 'Japan',
];

const STEPS = [
  { step: '01', icon: <FaFileAlt />, title: 'Send Inquiry',       desc: 'Share your product requirements, quantities, and specifications via email or our contact form.' },
  { step: '02', icon: <FaBoxOpen />, title: 'Get Quotation',      desc: 'Receive a detailed quote with pricing, lead time, and quality certificates within 24 hours.' },
  { step: '03', icon: <FaPlane />,   title: 'Confirm Order',      desc: 'Approve the proforma invoice, arrange payment, and production begins immediately.' },
  { step: '04', icon: <FaShip />,    title: 'Shipment & Delivery',desc: 'Products are shipped via air or sea freight with full tracking to your destination.' },
];

export default function Export() {
  return (
    <section className="export" id="export">

      <div className="export__banner">
        <div className="container">
          <SectionTitle
            title="Global Export Operations"
            subtitle="Delivering precision surgical instruments to medical professionals in 40+ countries"
            light
          />

          <div className="export__regions">
            <h4 className="export__regions-label">We Currently Export To:</h4>
            <div className="export__tags">
              {REGIONS.map(r => (
                <span className="export__tag" key={r}>{r}</span>
              ))}
              <span className="export__tag export__tag--more">+ Many More</span>
            </div>
          </div>
        </div>
      </div>

      <div className="export__process">
        <div className="container">
          <SectionTitle
            title="How to Order"
            subtitle="Simple 4-step process to get your surgical instruments from our factory to your facility"
          />

          <div className="export__steps">
            {STEPS.map(s => (
              <StepCard key={s.step} step={s.step} icon={s.icon} title={s.title} desc={s.desc} />
            ))}
          </div>
        </div>
      </div>

    </section>
  );
}
